import { useEffect } from "react";
import { LTIK_LS_KEY } from "../../api";
import { SESSION_DATA_LS_KEY } from "../../stores/sessionData/initializeSessionData";

export default function LogoutRoute() {
    useEffect(() => {
        localStorage.removeItem(SESSION_DATA_LS_KEY);
        localStorage.removeItem(LTIK_LS_KEY);

        window.location.replace("/");
    }, []);

    return null;
}
